import { Divider, TextField } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import BasicButtons from "../../UI/BasicButtons";
import { PDFDownloadLink } from "@react-pdf/renderer";
import PDFFile from "../../documenty/dogovor/PDFdogovor";
import { useUpdateDogovorMutation } from "../../../store/dogovorApi";
import ScrollDialog from "../../UI/ScrollModal";
import Files from "../../UI/Files";
import FileUploadButton from "../../UI/FileUploadButton";
import { backUrl } from "../../../config";
import { useSelector } from "react-redux";
import { generatePaymentSchedule } from "../../../utilits/helpers/generatePaymentSchedule";

const procent = {
  neustoika: "1%",
  shtraf: "20%",
};

export default function Dogovor({
  item,
  onClose,
  id,
  organization,
  paymentCodes,
}) {
  const { accessToken } = useSelector((state) => state.auth);
  const [updateData] = useUpdateDogovorMutation();
  const [docDate, setDocDate] = React.useState(item.attributes.docDate);
  const [numberDogovor, setNumberDogovor] = React.useState(
    item.attributes.numberDogovor
  );
  const [protocol, setProtocol] = React.useState(item.attributes.protocol);
  const [dateDogovorFrom, setDateDogovorFrom] = React.useState(
    item.attributes.dateDogovorFrom
  );
  const [dateDogovorTo, setDateDogovorTo] = React.useState(
    item.attributes.dateDogovorTo
  );
  const [contragent, setContragent] = React.useState(
    item.attributes.contragent.data[0].attributes.surname +
      " " +
      item.attributes.contragent.data[0].attributes.name +
      " " +
      item.attributes.contragent.data[0].attributes.lastname
  );
  const [address, setAddress] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.address +
      " " +
      item.attributes.nomenklatura.data[0].attributes.addressNumber
  );
  const [coordinates, setCoordinates] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.coordinates
  );
  const [nomenklatura, setNomenklatura] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.name
  );
  const [inn, setInn] = React.useState(
    item.attributes.contragent.data[0].attributes.inn
  );
  const [totalSum, setTotalSum] = React.useState(item.attributes.totalSum);
  const [nalog, setNalog] = React.useState(item.attributes.nalog);
  const [identCode, setIdentCode] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.inventNumber
  );
  const [autor, setAutor] = React.useState(
    item.attributes.user.data[0].attributes.username
  );
  const [square, setSquare] = React.useState(
    item.attributes.nomenklatura.data[0].attributes.square
  );
  const [purpose, setPurpose] = React.useState(item.attributes.purpose);
  const [invoice, setInvoice] = React.useState(item.attributes.invoice);
  const [filesIsOpen, setFilesIsOpen] = React.useState(false);
  const [selectedFiles, setSelectedFiles] = React.useState([]);
  const [uploadedFiles, setUploadedFiles] = React.useState([]);

  const phone = item.attributes.contragent.data[0].attributes.phone;

  const attachments = item.attributes.attachments
    ? item.attributes.attachments
    : [];

  const paymentSchedule = JSON.stringify(
    generatePaymentSchedule(
      new Date(dateDogovorFrom), new Date(dateDogovorTo), totalSum)  
  );

  const handleFileChange = (files) => {
    setSelectedFiles(files);
  };

  const inputChangeHandler = (event, setValue) => {
    setValue(event.target.value);
  };

  const formSubmitHandler = (event) => {
    event.preventDefault();
    window.alert("Сохранение изменений!");
    const updated = {
      docDate,
      protocol,
      numberDogovor,
      dateDogovorFrom,
      dateDogovorTo,
      totalSum,
      contragent: item.attributes.contragent.data[0].id,
      nomenklatura: item.attributes.nomenklatura.data.id,
      user: item.attributes.user.data.id,
      invoice,
      nalog,
      attachments: uploadedFiles.concat(attachments),
      schedule: paymentSchedule,
    };
    updateData({ updated, id });
    onClose();
  };
console.log(paymentSchedule)
  const FormUploadFileHandler = async (event) => {
    event.preventDefault();
    const formData = new FormData();
    if (selectedFiles) {
      for (let i = 0; i < selectedFiles.length; i++) {
        formData.append("files", selectedFiles[i]);
      }
    }

    try {
      const response = await fetch(`${backUrl}upload`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        const responseData = await response.json();
        setUploadedFiles(responseData);
      } else {
        console.error("Upload failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  return (
    <StyledForm onSubmit={formSubmitHandler}>
      <TitleOfContragent>Информация о договоре</TitleOfContragent>
      <BlockStyled margin="0 0 20px 0" width="100%">
        <BlockStyled width="100%" display="flex" justifyContent="space-between">
          <TextFieldStylded
            id="date"
            type="date"
            label="Дата документа"
            InputLabelProps={{ shrink: true }}
            variant="outlined"
            value={docDate}
            onChange={(event) => inputChangeHandler(event, setDocDate)}
            size="small"
            width="150px"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="№ договора"
            variant="outlined"
            value={numberDogovor}
            onChange={(event) => inputChangeHandler(event, setNumberDogovor)}
            size="small"
            width="5vw"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="На основании"
            variant="outlined"
            value={protocol}
            onChange={(event) => inputChangeHandler(event, setProtocol)}
            width="20vw"
            size="small"
          />
          <BlockStyled
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="0 10px"
            width="10px"
          >
            с
          </BlockStyled>
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Сроки договора"
            variang="outlined"
            value={dateDogovorFrom}
            onChange={(event) => inputChangeHandler(event, setDateDogovorFrom)}
            size="small"
            width="150px"
          />
          <BlockStyled
            display="flex"
            justifyContent="center"
            alignItems="center"
            margin="0 10px"
            width="10px"
          >
            по
          </BlockStyled>
          <TextFieldStylded
            id="date"
            type="date"
            InputLabelProps={{ shrink: true }}
            label="Сроки договора"
            variant="outlined"
            value={dateDogovorTo}
            onChange={(event) => inputChangeHandler(event, setDateDogovorTo)}
            width="150px"
            size="small"
          />
        </BlockStyled>
        <BlockStyled
          width="100%"
          margin="20px 0 0 0"
          display="flex"
          justifyContent="space-between"
        >
          <TextFieldStylded
            id="outlined-basic"
            label="Контрагент"
            variant="outlined"
            value={contragent}
            onChange={(event) => inputChangeHandler(event, setContragent)}
            size="small"
            width="33%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="ИНН"
            variant="outlined"
            value={inn}
            onChange={(event) => inputChangeHandler(event, setInn)}
            size="small"
            width="18%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма налога"
            variant="outlined"
            value={nalog}
            onChange={(event) => inputChangeHandler(event, setNalog)}
            size="small"
            width="12%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Сумма"
            variant="outlined"
            value={totalSum}
            onChange={(event) => inputChangeHandler(event, setTotalSum)}
            size="small"
            width="12%"
          />
          <TextFieldStylded
            id="outlined-basic"
            label="Лицевой счет"
            inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
            variant="outlined"
            value={invoice}
            onChange={(event) => inputChangeHandler(event, setInvoice)}
            size="small"
            width="15%"
          />
        </BlockStyled>
      </BlockStyled>
      <DividerStyled light margin="30px 0" />
      <BlockStyled
        margin="20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Номенклатура"
          variant="outlined"
          value={nomenklatura}
          onChange={(event) => inputChangeHandler(event, setNomenklatura)}
          width="25%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Идентификационный код"
          value={identCode}
          onChange={(event) => inputChangeHandler(event, setIdentCode)}
          width="20%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Площадь"
          variant="outlined"
          value={square}
          onChange={(event) => inputChangeHandler(event, setSquare)}
          width="10%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Целевое назначение"
          variant="outlined"
          value={purpose}
          onChange={(event) => inputChangeHandler(event, setPurpose)}
          width="35%"
        />
      </BlockStyled>
      <BlockStyled
        width="100%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="space-between"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Расположенный по адресу"
          variant="outlined"
          value={address}
          onChange={(event) => inputChangeHandler(event, setAddress)}
          width="50%"
        />
        <TextFieldStylded
          id="outlined-basic"
          label="Координаты"
          variant="outlined"
          value={coordinates}
          onChange={(event) => inputChangeHandler(event, setCoordinates)}
          width="45%"
        />
      </BlockStyled>
      <ScrollDialog
        open={filesIsOpen}
        closeModal={() => setFilesIsOpen(false)}
        save={formSubmitHandler}
        title="Файлы"
        isChangedData={uploadedFiles.length ? true : false}
        actionButtons={
          <>
            <FileUploadButton
              buttonName={
                selectedFiles.length
                  ? `Выбрано файлов (${selectedFiles.length})`
                  : `Выбрано файлов (${selectedFiles.length})`
              }
              onFileChange={handleFileChange}
              width="250px"
            />
            <BasicButtons type="submit" onClick={FormUploadFileHandler}>
              Загрузить
            </BasicButtons>
          </>
        }
      >
        <Files uploadedFiles={uploadedFiles} attachments={attachments} />
      </ScrollDialog>
      <BlockStyled
        width="100%"
        margin="0 0 20px 0"
        display="flex"
        justifyContent="flex-start"
        gap="10px"
      >
        <TextFieldStylded
          id="outlined-basic"
          label="Автор"
          variant="outlined"
          value={autor}
          onChange={(event) => inputChangeHandler(event, setAutor)}
          width="180px"
          size="small"
        />
      </BlockStyled>

      <StyledButtonsdBlock>
        <BlockStyled
          display="flex"
          flexDirection="flex-start"
          alignItems="center"
        ></BlockStyled>

        <BlockStyled display="flex" flexDirection="flex-end">
          <BasicButtons onClick={() => setFilesIsOpen(true)}>
            Файлы
          </BasicButtons>
          <BasicButtons>
            <a
              rel="noreferrer"
              target="_blank"
              href={`https://www.google.com/maps?q=${coordinates}`}
              style={{ textDecoration: "none", color: "inherit" }}
            >
              на карте
            </a>
          </BasicButtons>
          <PDFDownloadLink
            document={
              <PDFFile
                organization={organization}
                contragent={item.attributes.contragent.data[0].attributes}
                protocol={protocol}
                docDate={docDate}
                numberDogovor={numberDogovor}
                identCode={identCode}
                dateDogovorTo={dateDogovorTo}
                square={square}
                purpose={purpose}
                address={address}
                totalSum={totalSum}
                zemNalog={nalog}
                procent={procent}
                paymentCodes={paymentCodes}
                phone={phone}
              />
            }
            fileName={`Dogovor_№${numberDogovor}_${new Date(
              docDate
            ).toLocaleDateString()}.pdf`}
          >
            {({ loading }) =>
              loading ? (
                <BasicButtons>pdf...</BasicButtons>
              ) : (
                <BasicButtons>pdf</BasicButtons>
              )
            }
          </PDFDownloadLink>
          <BasicButtons onClick={onClose}>Отменить</BasicButtons>
          <BasicButtons type="submit">Сохранить</BasicButtons>
        </BlockStyled>
      </StyledButtonsdBlock>
    </StyledForm>
  );
}

const BlockStyled = styled.div`
  width: ${(props) => props.width};
  display: ${(props) => props.display};
  justify-content: ${(props) => props.justifyContent};
  flex-direction: ${(props) => props.flexDirection};
  margin: ${(props) => props.margin};
  padding: ${(props) => props.padding};
  align-items: ${(props) => props.alignItems};
  gap: ${(props) => props.gap};
`;

const TextFieldStylded = styled(TextField)`
  width: ${(props) => props.width};
  margin: ${(props) => props.mrg};
`;

const DividerStyled = styled(Divider)`
  margin: ${(props) => props.margin};
`;

const StyledButtonsdBlock = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
`;
const TitleOfContragent = styled.h3`
  text-align: center;
`;

const StyledForm = styled.form``;
